<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div>
          <div class="headline">Benefit Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.benefit }}</td>
          <td class="text-xs-left">{{ props.item.benShortDesc }}</td>
          <td class="text-xs-left">{{ props.item.benLongDesc }}</td>
          <td class="text-xs-left">{{ props.item.benTypeDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptDelete(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Benefit<v-icon>mdi-plus</v-icon></v-btn>
    </v-card>
    <v-dialog v-model="benefitDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.valueFormTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 v-if="newBenefit">
                  <v-text-field v-model="benefitForm.benefit" :label="labels.benefit" :error-messages="errors.collect('benefit')" data-vv-name="benefit" :data-vv-as="labels.benefit" v-validate="'required|param|max:4'"></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.benefit}}</v-subheader>
                  <div class="subheading">{{benefitForm.benefit}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :items="benType" v-model="benefitForm.benType" :label="labels.benType" item-text="label" item-value="value" data-vv-name="benType" :data-vv-as="labels.benType" :error-messages="errors.collect('benType')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="benefitForm.benShortDesc" :label="labels.benShortDesc" :error-messages="errors.collect('benShortDesc')" v-validate="'required|entry|max:20'" data-vv-name="benShortDesc" :data-vv-as="labels.benShortDesc"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="benefitForm.benLongDesc" :label="labels.benLongDesc" :error-messages="errors.collect('benLongDesc')" v-validate="'required|entry|max:40'" data-vv-name="benLongDesc" :data-vv-as="labels.benLongDesc"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Benefit Code', value: 'benefit' },
        { text: 'Benefit Short Description', value: 'benShortDesc' },
        { text: 'Benefit Long Description', value: 'benLongDesc' },
        { text: 'Benefit Type', value: 'benTypeDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Benefit Details',
        benefit: 'Benefit Code',
        benShortDesc: 'Benefit Short Description',
        benLongDesc: 'Benefit Long Description',
        benType: 'Benefit Type'
      },
      benefitForm: {
        benefit: null,
        benShortDesc: null,
        benLongDesc: null,
        benType: null
      },
      benType: [],
      benefitDialog: null,
      newBenefit: null,
      selectedId: {
        id: null,
        text: null
      },
      promptRemove: false
    }
  },
  computed: {
    benefit() {
      return this.$store.state.parameters.benefit
    }
  },
  methods: {
    async init() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiURI = this.benefit.menu.getBenefits
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((benefit) => {
              const convertCover = {
                benefit: benefit.benefit,
                benShortDesc: benefit.benShortDesc,
                benLongDesc: benefit.benLongDesc,
                benTypeCode: benefit.benTypeCode,
                benTypeDesc: benefit.benTypeDesc
              }
              this.items.push(convertCover)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      await this.$store.dispatch('benefitInit')
      this.init()
      this.getBenefitType()
    },
    async doReview(data) {
      this.benefitDialog = true
      const apiURI = this.benefit.menu.getBenefit
      const expand = {
        benefit: data.item.benefit
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.benefitForm.benefit = data.benefit.benefit
          this.benefitForm.benShortDesc = data.benefit.benShortDesc
          this.benefitForm.benLongDesc = data.benefit.benLongDesc
          this.benefitForm.benType = data.benefit.benTypeCode
        }
        this.benefitDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newBenefit = true
      this.benefitDialog = true
    },
    doClose() {
      this.newBenefit = false
      this.benefitDialog = false
      this.benefitForm.benefit = null
      this.benefitForm.benShortDesc = null
      this.benefitForm.benLongDesc = null
      this.benefitForm.benType = null
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newBenefit) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.benefit.menu.createBenefit
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.benefitForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.benefit.menu.updateBenefit
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.benefitForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getBenefitType() {
      const apiURI = this.benefit.menu.getBenefitType
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.benType = data.BenTypeList
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    doPromptDelete(benefit) {
      this.resetMessages()
      this.selectedId.id = benefit.benefit
      this.selectedId.text = benefit.benefit + ' - ' + benefit.benShortDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.benefit.menu.deleteBenefit
      if (apiURI) {
        const expand = {
          benefit: this.selectedId.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.init()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
